<style>
  body {
    background: #f8f8f8;
    margin: 0;
    padding: 0;
  }

  p {
    margin: 0;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
  }

  .header {
    padding: 40px;
  }

  .content {
    background: #fff;
  }
  table.tbl_admin_write{}
  table.tbl_admin_write th{background-color: #f8f8f8; vertical-align: middle;}
  table.tbl_admin_write td{text-align: left;}
  table.tbl_admin_write td textarea{width: 100%; padding: 15px; box-sizing: border-box; border: 1px solid #dedede; resize: vertical; height: 160px; min-height: 160px;}



  input.upload_text {/*읽기전용 인풋텍스트*/
    float:left;
    width:230px;/* 버튼 포함 전체 가로 길이*/
    height:35px;
    line-height:19px;
    padding:0 3px;
    border:1px solid #bbb;
  }

  div.upload-btn_wrap input.input_file {/*파일찾기 폼 투명하게*/
    position:absolute;
    top:0;
    right:0;
    cursor:pointer;
    opacity:0;
    filter:alpha(opacity=0);
    -ms-filter:"alpha(opacity=0)";
    -moz-opacity:0;
  }
  div.upload-btn_wrap {/*버튼테두리 감싼 div*/
    overflow:hidden;
    position:relative;
    float:left;
    width:70px;/*width, height 값은 button(찾아보기)값과 같아야함 */
    height:35px;
    padding-left:3px;
  }
  div.upload-btn_wrap button {/*버튼 div*/
    width:70px;
    height:35px;
    font-weight:bold;
    background:#333;
    border:1px solid #333;
    color:#fff;
  }

</style>

<template>
  <div id="component">
    <CRow>
      <CCol sm="8">
        <CCard>
          <CCardHeader>
            건강상태 상세
          </CCardHeader>
          <CCardBody>
            <CForm>
              <CInput prepend="대상자이름" v-model="name" disabled>
                <template #append-content>
                  <CIcon name="cil-user"/>
                </template>
              </CInput>
              <CInput prepend="대상자진료번호" v-model="registNo" disabled>
                <template #append-content>
                  <CIcon name="cil-user"/>
                </template>
              </CInput>
           <!--   <CInput prepend="환자번호" v-model="custId" disabled>
                <template #append-content>
                  <CIcon name="cil-user"/>
                </template>
              </CInput>-->
              <CInput type="date" v-model="checkDate"  prepend="날짜" min="2000-01-02" max="2999-12-31" >
              </CInput>
              <div style="display: inline-block;">
                <div class="input-group" style="margin-bottom: 1rem;">
                  <div class="input-group-prepend">
                    <span class="input-group-text">식사량</span>
                    <div class="input-group-append form-control col-sm-8" style="padding: 0px;">
                    <!--  <select id="uid-utosbj1koo" v-model="item1" required="required"
                              class="col-sm-12" style="border: 0px solid">
                        <option value="1">적음</option>
                        <option value="2">보통</option>
                        <option value="3">좋음</option>
                      </select>-->
                      <div class="input-group">
                        <div class="col-md-12 col-form-label">
                          <div class="form-check form-check-inline mr-1">
                            <label class="form-check-label" for="inline-radio1">나쁨</label>
                            <input class="form-check-input" id="inline-radio1" type="radio" value="1" v-model="item1">
                          </div>
                          <div class="form-check form-check-inline mr-1">
                            <label class="form-check-label" for="inline-radio2">보통</label>
                            <input class="form-check-input" id="inline-radio2" type="radio" value="2" v-model="item1">
                          </div>
                          <div class="form-check form-check-inline mr-1">
                            <label class="form-check-label" for="inline-radio3">좋음</label>
                            <input class="form-check-input" id="inline-radio3" type="radio" value="3" v-model="item1">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="display: inline-block;padding-left: 10px;">
                <div class="input-group-prepend">
                  <span class="input-group-text">대소변</span>
                  <div class="input-group-append form-control col-sm-8" style="padding: 0px;">
                    <!--<select id="uid-utosbj1koo" v-model="item2" required="required"
                            class="col-sm-12" style="border: 0px solid">
                      <option value="1">나쁨</option>
                      <option value="2">보통</option>
                      <option value="3">좋음</option>
                    </select>-->
                    <div class="input-group">
                      <div class="col-md-12 col-form-label">
                        <div class="form-check form-check-inline mr-1">
                          <label class="form-check-label" for="inline-radio1">나쁨</label>
                          <input class="form-check-input" id="inline-radio1" type="radio" value="1" v-model="item2">
                        </div>
                        <div class="form-check form-check-inline mr-1">
                          <label class="form-check-label" for="inline-radio2">보통</label>
                          <input class="form-check-input" id="inline-radio2" type="radio" value="2" v-model="item2">
                        </div>
                        <div class="form-check form-check-inline mr-1">
                          <label class="form-check-label" for="inline-radio3">좋음</label>
                          <input class="form-check-input" id="inline-radio3" type="radio" value="3" v-model="item2">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <CInput type="textarea" v-model="memo" prepend="보호사의견">
                <template #append-content></template>
              </CInput>
              <div class="card-body p-3 d-flex align-items-center">
                <div class="bg-gradient-warning mfe-3">
                </div>
              </div>
              <form style="margin-bottom: 20px;">

                <div class="box-file-input">
                  <div v-if="fileName == ''">
                    <label>
                      <input type="file" name="uploadFile" id="uploadFile" class="file-input">
                    </label>
                  </div>
                </div>

                <div v-if="fileName != ''">
                  <div>
                  <!--input box-->
                    <a  v-bind:href="'/silver/fileAttachLoad?attachId=' + attachId"> <input style="cursor:pointer;" type="text" class="upload_text" v-model="fileName" readonly="readonly"></a>
                  <!--button-->
                  </div>
                    <label>
                      <div class="upload-btn_wrap">
                        <button type="button" title="파일삭제" @click="delAttach" >
                          <span>파일삭제</span>
                        </button>
                      </div>
                    </label>
                  </div>
              </form>
              <div class="form-group form-actions">
                <div class="col-sm-0.5">
                  <CButton label=""
                           type="button"
                           style="text-align: right"
                           class="btn btn-info " @click="backHistory">뒤로가기
                  </CButton>
                  <CButton label=""
                           type="button"
                           style="text-align: center; float: right; margin-right:10px;"
                           class="btn btn-info " @click="wellnesssInsert">수정
                  </CButton>
                </div>
              </div>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
  import Uploader from "vux-uploader-component";
  import VueMoment from 'vue-moment'
  import Vue from 'vue'
  import axios from "axios";

  Vue.use(VueMoment)

  export default {
    name: 'app',
    components: {
      Uploader
    },
    data() {
      return {
        custId: this.$route.params.custId,
        checkDate: this.$moment(this.$route.params.checkDate).format('YYYY-MM-DD'),
        item1: '2',
        item2: '2',
        name:"",
        registNo:"",
        url: '',
        item3: '',
        attachId: '',
        memo: '',
        adminId: '',
        fileName :'',
        fileList: [
        ]
      }
    },
    mounted() {

      axios.get("silver/cust/wellness/view",{
        params: { custId: this.$route.params.custId, checkDate : this.$route.params.checkDate },
        timeout: 10000 // 1초 이내에 응답이 없으면 에러 처리
      })
              .then(res => {
                console.log( res.data.cust.name);
                this.item1 = res.data.custWellness.item1;
                this.item2 = res.data.custWellness.item2;
                this.item3 = res.data.custWellness.item3;
                this.attachId = res.data.custWellness.attachId;
                this.custId = res.data.custWellness.custId;
                this.memo = res.data.custWellness.memo;
                this.adminId = res.data.custWellness.adminId;
                this.name = res.data.cust.name;
                this.registNo = res.data.cust.registNo;


                if (res.data.custWellness.attachId != null) {
                  if(res.data.attach.fileName != null && res.data.attach.fileName != ""  ){
                    this.fileName = res.data.attach.fileName;
                  }
                  this.fileList.push({url:'/silver/fileAttachLoad?attachId='+res.data.custWellness.attachId})
                  /*this.fileList.push({url:'http://localhost:8080/silver/fileAttachLoad?attachId='+res.data.custWellness.attachId})*/
                }
                console.log(this.fileList);
              })
              .catch(function(error) {
                console.log(error);
              });
    },
    methods: {
      onChange(fileItem, fileList) {
        console.log('on-change: ', fileItem, fileList)
      },
      onCancel() {
        console.log('on-cancel: Sucess')
      },
      onSuccess(res, fileItem) {
        console.log('on-success: ', res)
        fileItem.fileid = res.data
        this.attachId = res.attachId
        console.log(this.attachId);
      },
      onError(res) {
        console.log('on-error: ', res)
      },
      onDelete(cb) {
        this.attachId = '';
        console.log('on-delete: ', JSON.parse(JSON.stringify(this.fileList)))
        cb && cb()
      },
      wellnesssInsert() {
        var uploadFile = document.getElementById("uploadFile");

        const formData = new FormData();
        var custId =  this.$route.params.custId;

        if(uploadFile != null){
          formData.append("uploadFile",uploadFile.files[0]);
          formData.append("custId",this.$route.params.custId);
          formData.append("checkDate",this.$moment(this.checkDate).format('YYYYMMDD'));
          formData.append("item1",this.item1);
          formData.append("item2",this.item2);
          formData.append("item3",this.item3);
          formData.append("memo",this.memo);
        }else {
          if( this.attachId != ''){
            formData.append("custId",this.$route.params.custId);
            formData.append("checkDate",this.$moment(this.checkDate).format('YYYYMMDD'));
            formData.append("item1",this.item1);
            formData.append("item2",this.item2);
            formData.append("item3",this.item3);
            formData.append("memo",this.memo);
            formData.append("attachId",this.attachId);
          }else{
            formData.append("custId",this.$route.params.custId);
            formData.append("checkDate",this.$moment(this.checkDate).format('YYYYMMDD'));
            formData.append("item1",this.item1);
            formData.append("item2",this.item2);
            formData.append("item3",this.item3);
            formData.append("memo",this.memo);
          }

        }

        axios.post("silver/attachFileUpload", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(res => {
          alert("수정되었습니다.");
          this.$router.push({name: 'paymanageupdate', params: {custId: custId}});
        })
        .catch(function (error) {
          console.log(error);
        });
      },
      onload(e, r) {
        console.log(r)
      },
      backHistory() {
        this.$router.go(-1)
      },
      delAttach() {
          this.fileName='';
      },
      onChangedFile(files, event) {
        this.uploadFile = files;

        // get File object from input tag
        const file = event.target.files[0];

        if (file === undefined) {
          return;
        }

        // declare FileReader, temp result
        const reader = new FileReader();
        let tmpResult = {};

        // if you use "this", don't use "function(e) {...}"
        reader.onload = (e) => {
          let data = reader.result;
          data = new Uint8Array(data);
          // get prased object
          //기본 상단 내용 제외하고 실제 데이터부터 자르기

          let alertMessage = "";
          this.loading = false;

          if (alertMessage != "") {
            //validate 체크결과 alert
            alert(alertMessage);
            this.validateMsg = alertMessage;
            this.validate = false;

            //input file 초기화
            this.uploadReady = false;
            this.$nextTick(() => {
              this.uploadReady = true
            });

            return;
          }

          this.validate = true;
        };
        reader.readAsArrayBuffer(file);
        this.loading = true;
      }
    }
  }
</script>


